import { render, staticRenderFns } from "./files-list.vue?vue&type=template&id=f03854e2&scoped=true"
import script from "./files-list.vue?vue&type=script&lang=ts"
export * from "./files-list.vue?vue&type=script&lang=ts"
import style0 from "./files-list.vue?vue&type=style&index=0&id=f03854e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03854e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f03854e2')) {
      api.createRecord('f03854e2', component.options)
    } else {
      api.reload('f03854e2', component.options)
    }
    module.hot.accept("./files-list.vue?vue&type=template&id=f03854e2&scoped=true", function () {
      api.rerender('f03854e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/files-list/files-list.vue"
export default component.exports